import { types } from './types';

const INITIAL_STATE = {
  status: null,
  taxis_data: {
    mainKadCode: null,
  },
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GET_USER_DATA.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.GET_USER_DATA.ERROR:
      return {
        ...state,
        status: 400,
      };
    case types.GET_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.CHECK_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.UPDATE_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.UPDATE_USER_NP:
      return {
        ...state,
        loading: false,
      };
    case types.LOGIN_ERROR:
      return {
        ...state,
        hasError: true,
        message: payload,
        loading: false,
      };
    case types.SET_FORM_INFO:
      return { ...state, hasInfo: true, message: payload };
    case types.GET_TAXIS_DATA.SUCCESS:
      return {
        ...state,
        loading: false,
        taxis_data: { ...payload, afmTrimmed: payload.afm.trim() },
      };
    case types.GET_TAXIS_DATA.START:
      return {
        ...state,
        loading: true,
      };
    case types.GET_TAXIS_DATA.ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.CLEAR_USER:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
